
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
name: 'checkChoice',
props: {
choice: {},
cuIndex: 0
},
components: {
Checker, Group, Cell, CheckerItem
},
data () {
return {
options: [],
anwser: '',
haOptions: ''
}
},
created () {
this.setOptions(this.choice)
},
watch: {
choice: function () {
this.setOptions(this.choice)
}
},
methods: {
getAnswer () {
return this.choice
},
setOptions: function (choice) {
this.options = []
const {options} = choice.choices
const {userAnswer} = choice
this.options = options
if (userAnswer) {
this.anwser = userAnswer
}
},
setShowOk: function () {
for (let i = 0; i < this.options.length; i++) {
this.options[i].showOk = false
}
},
getOption: function (id) {
let option
for (let i = 0; i < this.options.length; i++) {
if (id === this.options[i].id) {
option = this.options[i]
break
}
}
return option
},
toggleOption (value) {
console.log(value)
if (value) {
this.setShowOk()
let option = this.getOption(value)
if (!option) {
return
}
option.showOk = true
if (option && option.inputMust && option.inputMust === '1' && option.inputType === '2') {
let parentCom = this.$refs[this.choice.id]
this.$nextTick(() => {
if (parentCom.$refs[value][0]) {
parentCom.$refs[value][0].focus()
}
})
}
let inputs = []
for (let i = 0; i < this.options.length; i++) {
if (value === this.options[i].id && this.options[i].inputVal) {
let temp = {}
temp.optionId = value
temp.optionInput = this.options[i].inputVal
inputs.push(temp)
break
}
}
this.choice.userInput = inputs
this.choice.userAnswer = value
this.$emit('on-autoshow', this.choice)

if (value.length > 0 && this.haOptions.length === 0) {





}
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/Subjects/SortChoices/index.vue